import { ProductAverageRating } from '@/components/ProductReviews/ProductAverageRating'
import type { SbBaseBlockProps } from '@/services/storyblok/storyblok'
import { storyblokEditable } from '@storyblok/react'

type Props = SbBaseBlockProps<{ centerAlign?: boolean }>

export function ProductAverageRatingBlock({ blok }: Props) {
  return <ProductAverageRating {...storyblokEditable(blok)} centerAlign={blok.centerAlign} />
}
